import { NewDynamicTab } from "../../../components/Page";
import { RuvitalGenration } from "../../../config/DefaultDates";
import { RuvnlTitle } from "../components";
import { TabSwitcher } from "../Raj_Dashboard";
import { BySource } from "./BySource";
import { OperatingPar } from "./OperatingPar";
import RajOutage from "./Outage";
import { RajGenOverview } from "./Overview";
import { ByPowerStation } from "./PowerStation";
import RajasthanTrend from "./TrendAnalysis";

export function RajGeneration() {
  return (
    <NewDynamicTab
      hideDateFilterOnTabs={["Operating Parameters"]}
      defaultDates={RuvitalGenration}
      trendTabs={["Trend Analysis"]}
      header="Generation"
      middleComponent={<RuvnlTitle />}
      headerPrefixComponent={<TabSwitcher />}
      tabs={{
        Overview: <RajGenOverview />,
        "Trend Analysis": <RajasthanTrend />,
        "By Source": <BySource />,
        "By Power Station": <ByPowerStation />,
        Outage: <RajOutage />,
        "Operating Parameters": <OperatingPar />,
      }}
    />
  );
}
